import { ArchiveRestore, Eraser } from 'lucide-react';
import { Button } from '@/components/ui/button';

type ConfigResetButtonsProps = {
  hasChanges: boolean;
  showRestore: boolean;
  isRestoreDisabled: boolean;
  onReset: () => void;
  onRestoreDefault: () => void;
};

export function ConfigResetButtons({
  hasChanges,
  showRestore,
  isRestoreDisabled,
  onReset,
  onRestoreDefault,
}: ConfigResetButtonsProps) {
  return (
    <>
      {showRestore && (
        <Button
          variant="outline"
          size="sm"
          className="h-7"
          onClick={onRestoreDefault}
          disabled={isRestoreDisabled}
        >
          <ArchiveRestore className="w-3 h-3 mr-1" />
          Restore default
        </Button>
      )}
      <Button
        variant="outline"
        size="sm"
        className="h-7"
        onClick={onReset}
        disabled={!hasChanges}
      >
        <Eraser className="w-3 h-3 mr-1" />
        Reset
      </Button>
    </>
  );
}
